/**
 * Minimal Permit2 ABI fragments for allowance reads and approve.
 *
 * Story 5.2 Task 2.2
 */

export const permit2Abi = [
	{
		type: "function",
		name: "allowance",
		stateMutability: "view",
		inputs: [
			{ name: "owner", type: "address" },
			{ name: "token", type: "address" },
			{ name: "spender", type: "address" },
		],
		outputs: [
			{ name: "amount", type: "uint160" },
			{ name: "expiration", type: "uint48" },
			{ name: "nonce", type: "uint48" },
		],
	},
	{
		type: "function",
		name: "approve",
		stateMutability: "nonpayable",
		inputs: [
			{ name: "token", type: "address" },
			{ name: "spender", type: "address" },
			{ name: "amount", type: "uint160" },
			{ name: "expiration", type: "uint48" },
		],
		outputs: [],
	},
] as const;
